import { BranchResponse } from "~/_legacy/types/api";
import { Branch } from "~/_legacy/types/common";
import axiosInstance from "./axios-instance";

const API_URL = "branches/";

export const fetchAllBranches = async () => {
  const { data } = await axiosInstance.get<BranchResponse[]>(API_URL);

  const converted: Branch[] = data.map((branch) => ({
    uid: branch.uid,
    name: branch.name,
    client: {
      uid: branch.client.uid,
      name: branch.client.name,
    },
    config: {
      status: branch.branch_config.status,
    },
    analyzingCameraCount: branch.camera_orientation_count,
    analyzingCountingLineCount: branch.counting_line_count,
    analyzingIntervalZoneCount: branch.interval_zone_count,
  }));

  return converted;
};
